import { defineComponent as _defineComponent } from 'vue'
import { useDialog } from "primevue/usedialog";
    import { ref } from "vue";
    import { useLoading } from 'vue3-loading-overlay';
    import commonModule from "@/composables/modules/commonModule";
    
export default /*@__PURE__*/_defineComponent({
  __name: 'commonDialog',
  props: {
        title: { type: String, default: "Manage Data" },
        class: { type: String, default: "" },
        closable: { type: Boolean, default: true },
    },
  setup(__props, { expose: __expose }) {

    let Props = __props;
    const closable = ref(Props.closable)
    const dialog = useDialog();
    const { ShowLoader, HideLoader } = new commonModule();
    const loader = useLoading();
    const OpenModal = (CustomerComponent: any,title:string, data: any, closeCallback: any) => {
        ShowLoader(loader);
        var newdata = JSON.stringify(data);
        const dialogRef = dialog.open(CustomerComponent, {
            props: {
                header: title&&title!=''? title: Props.title,
                modal: true,
                class: Props.class,
                draggable: false,
                closeOnEscape:false,
                closable:closable.value,
            },
            onClose: (options) => {
                if (closeCallback)
                    closeCallback(options.data);
            },
            data: JSON.parse(newdata),
            containerClass: 'large-modal'
        });
        HideLoader(loader);
    }
    const CloseModel=()=>{
        dialog.close();
    }
    const SetClosable=(Itm:any)=>{
        closable.value=Itm
    }
    __expose({ OpenModal,CloseModel,SetClosable })


const __returned__ = { get Props() { return Props }, set Props(v) { Props = v }, closable, dialog, ShowLoader, HideLoader, loader, OpenModal, CloseModel, SetClosable }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})